<template>
    <section class="about-section py-5">
        <div class="container">
            <!-- <div class="row align-items-center">
                <div class="col-lg-6 mb-4 mb-lg-0">
                    <div class="about-image position-relative">
                        <img src="@/assets/team.jpg" alt="Zespół Selam Rachunkowość" class="img-fluid rounded shadow">
                        <div class="experience-badge">
                            <span class="years">10+</span>
                            <span class="text">lat doświadczenia</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="about-content">
                        <h2 class="section-title mb-4">O naszej firmie</h2>
                        <p class="lead mb-4">Selam Rachunkowość to doświadczony zespół specjalistów z zakresu
                            księgowości, podatków i kadr.</p>
                        <p class="mb-4">Działamy na rynku od ponad 10 lat, świadcząc usługi dla firm z różnych branż.
                            Naszym priorytetem jest profesjonalizm, rzetelność i indywidualne podejście do każdego
                            klienta.</p>

                        <div class="key-facts row mt-5">
                            <div class="col-6 mb-4">
                                <div class="fact-item">
                                    <div class="fact-icon mb-2">
                                        <i class="fas fa-user-tie fa-2x text-primary"></i>
                                    </div>
                                    <h4 class="fact-number">500+</h4>
                                    <p class="fact-text">Zadowolonych klientów</p>
                                </div>
                            </div>

                            <div class="col-6 mb-4">
                                <div class="fact-item">
                                    <div class="fact-icon mb-2">
                                        <i class="fas fa-chart-line fa-2x text-primary"></i>
                                    </div>
                                    <h4 class="fact-number">10+</h4>
                                    <p class="fact-text">Lat na rynku</p>
                                </div>
                            </div>

                            <div class="col-6">
                                <div class="fact-item">
                                    <div class="fact-icon mb-2">
                                        <i class="fas fa-certificate fa-2x text-primary"></i>
                                    </div>
                                    <h4 class="fact-number">100%</h4>
                                    <p class="fact-text">Poufności danych</p>
                                </div>
                            </div>

                            <div class="col-6">
                                <div class="fact-item">
                                    <div class="fact-icon mb-2">
                                        <i class="fas fa-briefcase fa-2x text-primary"></i>
                                    </div>
                                    <h4 class="fact-number">15+</h4>
                                    <p class="fact-text">Ekspertów w zespole</p>
                                </div>
                            </div>
                        </div>

                        <div class="mt-5">
                            <router-link to="/o-nas" class="btn btn-outline-primary me-3">Poznaj nas
                                lepiej</router-link>
                            <router-link to="/zespol" class="btn btn-outline-secondary">Nasz zespół</router-link>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </section>
</template>

<script>
export default {
    name: 'AboutSection'
}
</script>

<style lang="scss" scoped>
.about-section {
    .section-title {
        color: var(--primary-color);
        position: relative;
        padding-bottom: 15px;

        &:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 50px;
            height: 3px;
            background-color: var(--secondary-color);
        }
    }

    .about-image {
        .experience-badge {
            position: absolute;
            bottom: -20px;
            right: -20px;
            background-color: var(--secondary-color);
            color: white;
            padding: 20px;
            border-radius: 50%;
            width: 120px;
            height: 120px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

            .years {
                font-size: 2rem;
                font-weight: bold;
                line-height: 1;
            }

            .text {
                font-size: 0.9rem;
            }
        }
    }

    .key-facts {
        .fact-item {
            text-align: center;

            .fact-icon {
                color: var(--secondary-color);
            }

            .fact-number {
                font-size: 1.8rem;
                font-weight: bold;
                color: var(--primary-color);
                margin-bottom: 0.3rem;
            }

            .fact-text {
                color: #6c757d;
                margin-bottom: 0;
            }
        }
    }
}
</style>